/** The stable code the API sends with a 403 when the user has not accepted the current terms (`TermsAcceptanceFilter`). */
export const TERMS_UPDATE_REQUIRED = 'terms_update_required'

/**
 * Whether a response is the API refusing a write because the terms changed. Reads a clone, so the body stays readable for the
 * caller (`ResponseError` consumers call `response.text()`). Any other status, a non-JSON body or another code is false.
 */
export async function isTermsUpdateRequired(response: Response | undefined): Promise<boolean> {
  if (!response || response.status !== 403) return false
  try {
    const body = await response.clone().json()
    return body?.code === TERMS_UPDATE_REQUIRED
  } catch {
    return false
  }
}
